module.exports = __webpack_public_path__ + "static/media/custom-wed-02.fce93b1d.jpg";